// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1MQFc","footer":"ModalCreateQualiphyProcedure_footer__3vaNF","additionData":"ModalCreateQualiphyProcedure_additionData__coQfv"};